import { useRef, useEffect } from 'react';
import { renderDownloadThrobber } from '@utils/common';
import { jsx } from 'react/jsx-runtime';

function Throbber(props) {
  const internalRef = useRef(null);
  const canvasRef = props.ref ?? internalRef;
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    renderDownloadThrobber(canvas, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/jsx("canvas", {
    className: props.className,
    ref: canvasRef
  });
}

export { Throbber };
//# sourceMappingURL=throbber.js.map
